/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { useEffect, useState } from "react";
import { getConfigValues } from "../sharedServices/configService";

const useRemoteConfig = (keys) => {
	const [config, setConfig] = useState([]);
	const [isLoading, setLoading] = useState(false);

	useEffect(() => {
		const fetchConfig = async () => {
			try {
				const newConfig = await getConfigValues(keys);
				setConfig(newConfig);
			} catch (error) {
				setConfig([]);
			} finally {
				setLoading(false);
			}
		};

		if (config.length === 0 && !isLoading) {
			setLoading(true);
			fetchConfig();
		}
	}, [keys, config, isLoading]);

	return { config };
};

export default useRemoteConfig;
